export default "__VITE_ASSET__2263fb8c__"